<script>
import axios from 'axios';
import { cmsUrl } from '../variables';
import LoadIndicator from '../components/LoadIndicator';

export default {
    name: 'OfferingForm',
    components: {
        LoadIndicator,
    },
    data() {
        return {
            offeringId: null,
            offeringData: { page_title: '', description: '', link: '', categories: [] },
            categories: [],
            locations: [],
            isLoading: false,
            isSaving: false,
            sendError: false,
            errors: [],
            selectedCategiries: [],
            selectedLocations: [],
        }
    },
    mounted() {
        this.offeringId = this.$route.params.offeringId ? this.$route.params.offeringId : null;
        this.initTaxonomie();
        if (this.offeringId)
            this.init(this.offeringId)
    },
    methods: {
        init(id) {
            this.isLoading = true;
            axios
                .get(cmsUrl + '/organisations/post?id=' + id)
                .then(this.onDataLoaded)
                .catch(() => this.onError())
        },
        initTaxonomie() {
            axios
                .get(cmsUrl + '/offer_categories')
                .then(this.onCategoriesLoaded)
                .catch(() => this.onError())
            axios
                .get(cmsUrl + '/offer_locations')
                .then(this.onLocationsLoaded)
                .catch(() => this.onError())
        },
        onDataLoaded(data) {
            if (!data || !data.data) {
                this.onError();
                return;
            }

            this.offeringData = data.data;
            this.isLoading = false;

            this.offeringData.offer_category.map(item => { this.selectedCategiries.push(item.term_id) });
            this.offeringData.offer_location.map(item => { this.selectedLocations.push(item.term_id) });

        },
        onCategoriesLoaded(data) {
            if (!data || !data.data) {
                this.onError();
                return;
            }
            this.categories = data.data;
        },
        onLocationsLoaded(data) {
            if (!data || !data.data) {
                this.onError();
                return;
            }
            this.locations = data.data;
        },
        onError() {
            // this.$router.push('page-not-found');
            this.isLoading = false;
        },
        onSubmit(e) {
            e.preventDefault();
            if (this.isSaving) return;
            
            this.errors = [];
            if (!this.offeringData.post_title)
                this.errors.push({concern: 'title', msg: this.$t('offeringForm.filedValidationMsgTitle')});
            if (!this.selectedCategiries.length > 0)
                this.errors.push({concern: 'category', msg: this.$t('offeringForm.filedValidationMsgCategory')});
            if (!this.selectedLocations.length > 0)
                this.errors.push({concern: 'location', msg: this.$t('offeringForm.filedValidationMsgLocation')});
            if (!/^(http|https):\/\/[^ "]+$/.test(this.offeringData.link))
                this.errors.push({concern: 'link', msg: this.$t('offeringForm.filedValidationMsgLink')});
            if (this.errors.length > 0) {
                this.scrollToFormTop();
                return;
            }
            
            this.isSaving = true;
            this.sendError = false;
            axios
                .post(cmsUrl + '/organisations/post', {
                    id: this.offeringId,
                    organisation_id: this.$route.params.organisationId,
                    title: this.offeringData.post_title,
                    description: this.offeringData.description,
                    link: this.offeringData.link,
                    type: 'offer',
                    offer_category: this.selectedCategiries,
                    offer_location: this.selectedLocations,
                },
                {
                    headers: { }
                })
                .then(() => {
                    this.isSaving = false;
                    this.$router.push('/organisation/' + this.$route.params.organisationId);
                })
                .catch(() => {
                    this.isSaving = false;
                    this.sendError = true;
                    this.scrollToFormTop();
                })
            
        },
        onCancel(e) {
            e.preventDefault();
            this.$router.push('/organisation/' + this.$route.params.organisationId);
        },
        scrollToFormTop() {
            setTimeout(() => {
                window.scrollTo(0, this.$refs.form.offsetTop - 100);
            }, 100)
        },
        onLocationSelect(tagId) {
            const index = this.selectedLocations.indexOf(tagId);
            index > -1 ? this.selectedLocations.splice(index, 1) : this.selectedLocations.push(tagId);
        },
        onCategorySelect(tagId) {
            const index = this.selectedCategiries.indexOf(tagId);
            index > -1 ? this.selectedCategiries.splice(index, 1) : this.selectedCategiries.push(tagId);
        },
    },
    computed: {
        routerKey() {
            return this.$route.path;
        },
    },
};
</script>

<template>
    <section class="offering-form">
        <h1 class="offering-form__title page-title">
            <span v-if="$route.params.offeringId">{{$t('offeringForm.titleEdit')}}</span>
            <span v-if="!$route.params.offeringId">{{$t('offeringForm.titleCreate')}}</span>
        </h1>

        <form ref="form" action="" class="offering-form__form" v-if="!isLoading">
            <div class="offering-form__error">
                <h2 class="offering-form__error-title" v-if="errors.length > 0">{{$t('offeringForm.formValidationError')}}</h2>
                <h2 class="offering-form__error-title" v-if="sendError">{{$t('offeringForm.sendError')}}</h2>
            </div>

            <div class="offering-form__input-group form-control">
                <label class="offering-form__label form-control__label" for="">{{$t('offeringForm.inputLabelTitle')}}</label>
                <input class="offering-form__control form-control__input" type="text" name="title" v-model="offeringData.post_title">
                <div class="offering-form__error-msg" v-if="errors.find(item => item.concern === 'title')">{{errors.find(item => item.concern === 'title').msg}}</div>
            </div>

            <div class="offering-form__input-group form-control">
                <label class="offering-form__label form-control__label" for="">{{$t('offeringForm.inputLabelDescription')}}</label>
                <textarea class="offering-form__control form-control__input" name="description" rows="3" v-model="offeringData.description"></textarea>
            </div>

            <div class="offering-form__input-group form-control">
                <label class="offering-form__label form-control__label" for="">{{$t('offeringForm.inputLabelLink')}}</label>
                <input class="offering-form__control form-control__input" type="text" name="link" v-model="offeringData.link" placeholder="https://www.domain.ch">
                <div class="offering-form__error-msg" v-if="errors.find(item => item.concern === 'link')">{{errors.find(item => item.concern === 'link').msg}}</div>
            </div>

            <div class="offering-form__input-group form-control">
                <label class="offering-form__label form-control__label" for="">{{$t('offeringForm.inputLabelCategory')}}</label>
                <div class="offering-form__error-msg" v-if="errors.find(item => item.concern === 'category')">{{errors.find(item => item.concern === 'category').msg}}</div>
                <div class="offering-form__tag-container">
                    <div 
                        class="offering-form__tag" 
                        v-for="tag in categories" 
                        v-bind:key="tag.id" 
                        v-bind:class="[{'offering-form__tag--selected': selectedCategiries.find(item => item === tag.id)}]"
                        v-on:click="onCategorySelect(tag.id)">
                        <span class="offering-form__tag__label" v-html="tag.name"></span>
                    </div>
                </div>
            </div>

            <div class="offering-form__input-group form-control">
                <label class="offering-form__label form-control__label" for="">{{$t('offeringForm.inputLabelLocation')}}</label>
                <div class="offering-form__error-msg" v-if="errors.find(item => item.concern === 'location')">{{errors.find(item => item.concern === 'location').msg}}</div>
                <div class="offering-form__tag-container">
                    <div 
                        class="offering-form__tag" 
                        v-for="tag in locations" 
                        v-bind:key="tag.id" 
                        v-bind:class="[{'offering-form__tag--selected': selectedLocations.find(item => item === tag.id)}]"
                        v-on:click="onLocationSelect(tag.id)">
                        <span class="offering-form__tag__label" v-html="tag.name"></span>
                    </div>
                </div>
            </div>

            <p class="offering-form__draft-note" v-if="!$route.params.offeringId">{{$t('offeringForm.draftNote')}}</p>

            <div class="offering-form__actions">
                <button class="button button--primary" v-on:click="onSubmit($event)"><span v-if="!isSaving">{{$t('offeringForm.buttonSave')}}</span><span v-if="isSaving">{{$t('offeringForm.loading')}}</span></button>
                <button class="button button--secondary" v-on:click="onCancel($event)">{{$t('offeringForm.buttonCancel')}}</button>
            </div>
        </form>
        <load-indicator v-if="isLoading" />
    </section>
</template>

<style lang="scss" scoped>
.offering-form__actions {
    margin-top: 8rem;
}
.offering-form__draft-note {
    max-width: 41.6rem;
    margin:  6.4rem 0 -3.2rem;
}
.offering-form__error-title {
    margin-bottom: 4rem;
    font-weight: 300;
    font-size: 2rem;
    color: $color-danger;
}
.offering-form__error-msg {
    margin: -1.6rem 0 2.4rem;
    font-size: 1.44rem;
    color: $color-danger;
}
.offering-form__tag-container {
    display: flex;
    flex-wrap: wrap;
    margin: -0.4rem;
    padding-bottom: 3.2rem;
}
.offering-form__tag {
    margin: 0.4rem;
    padding: 0.8rem;
    border-radius: 0.16rem;
    background: rgba($color-primary, .15);
    cursor: pointer;
    transition: background 200ms linear;
}
.offering-form__tag:hover {
    @include breakpoint('sm-up') {
        background: rgba($color-primary, .25);
    }
}
.offering-form__tag--selected {
    background: $color-primary-alt;
    color: $color-light;
}
.offering-form__tag--selected:hover {
    @include breakpoint('sm-up') {
        background: $color-primary-alt;
    }
}
</style>
